










































































































































import moment from "moment/moment";
import { mixins } from "vue-class-component";
import axios from "@/plugins/axios";
import { Component } from "vue-property-decorator";
import VueJsonToCsv from "vue-json-to-csv";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {
    VueJsonToCsv,
  },
})
export default class Tracker extends mixins(ErrorMixin) {
  public loadData = false;
  public trackers: { [key: string]: { [key: string]: number } } = {};

  public rapportParNbr: { [key: string]: number } = {};
  public sortedRapports = new Array();
  public regExp = /[a-zA-Z0-9]/g;
  public search: string = "";
  public searchRep: string = "";
  public unusedRapports = new Array();
  public showUnused = false;
  public showUnusedSites = false;
  public unusedSites = new Array();
  // public repParSite: {[key: string]: {[key: string]: number}} = {};
  // public filtererReps = new Array();

  public mounted() {
    this.loadData = true;
    this.trackers = this.metrics;
    const keys = Object.keys(this.metrics);
    // console.log(keys);
    for (const key of keys) {
      // let maKey = parseInt(key);
      // console.log(maKey, key);
      // if (this.regExp.test(key)) {
      const siteReps = this.metrics[key];
      // console.log(siteReps);
      for (const rap of Object.keys(siteReps)) {
        if (rap === "FeuilleCaisseReport" && this.client === "BK") {
          const name = "SyntheseCAReport";
          if (this.rapportParNbr[name] !== undefined) {
            this.rapportParNbr[name] += siteReps[rap];
          } else {
            this.rapportParNbr[name] = siteReps[rap];
          }
        } else if (this.rapportParNbr[rap] !== undefined) {
          this.rapportParNbr[rap] += siteReps[rap];
        } else {
          this.rapportParNbr[rap] = siteReps[rap];
        }
      }
      /*} else {
        console.log(key);
        delete this.trackers[key];
      }*/
    }
    this.sortRapports();
    // console.log(this.rapportParNbr);
    this.loadData = false;
    this.checkUnusedRap();
    this.checkUnusedSites();
  }
  /**
   * méthode de transforamtion des données recues en données exploitables
   */
  public trackersSites() {
    const sites: { [key: string]: { [key: string]: number } } = {};
    for (const key of Object.keys(this.trackers)) {
      if (this.search === "" || key.includes(this.search.toUpperCase())) {
        sites[key] = this.trackers[key];
      }
    }
    return sites;
  }
  /**
   * méthode de récupération des rapports non utilisés
   */
  public checkUnusedRap() {
    let unused = this.allReports.map((rapport: any) => rapport.localisedTitle);
    this.sortedRapports.map((rep: any) => {
      if (unused.indexOf(rep.nom) !== -1) {
        unused = unused.filter((rapportName: string) => {
          return !rapportName.includes(rep.nom);
        });
      }
    });
    // console.log(unused);
    this.unusedRapports = unused;
  }

  public checkUnusedSites() {
    this.unusedSites = new Array();
    for (const site of this.sites) {
      if (this.trackers[site.libelle] === undefined) {
        // console.log(site.nom, "ne sort pas de rapport");
        this.unusedSites.push(site);
      }
    }
  }
  /**
   * récupération des rapports filtrés
   */
  public getFilteredRapports() {
    if (this.searchRep === "") {
      return this.sortedRapports;
    } else {
      return this.sortedRapports.filter((rap: any) =>
        rap.nom.toLowerCase().includes(this.searchRep.toLowerCase())
      );
    }
  }
  /**
   * méthode d'ajout d'un horodatage en fin de titre pour avoir un suivi du tracker
   * @param titre le titre du rapport
   */
  public getTitle(titre: string) {
    return `${titre} ${moment().format("YYYYMMDD")}`;
  }
  /**
   * methode de récupéraction des rapports par site pour transformation en csv
   */
  public getCsvSites() {
    const sites = Object.keys(this.trackers);
    const data = new Array();
    for (const si of sites) {
      const reps = Object.keys(this.trackers[si]);
      for (const rep of reps) {
        // console.log(rep, this.repParSite[si][rep] );
        data.push({
          id: this.getSiteId(si),
          libSite: si,
          rapport: this.findTranslatedName(rep),
          qte: this.trackers[si][rep],
        });
      }
    }
    return data;
  }
  /**
   * méthode de récupération des rapports pour tranformation en csv
   */
  public getCsvRapports() {
    return this.sortedRapports;
  }
  /**
   * methode de tri et filtrage des rapports
   */
  private sortRapports() {
    this.sortedRapports = new Array();
    const reps = Object.keys(this.rapportParNbr);
    console.log(this.rapportParNbr);
    reps.map((rapport: any) => {
      const rapName = this.findTranslatedName(rapport);
      this.sortedRapports.push({
        nom: rapName,
        nbr: this.rapportParNbr[rapport],
      });
    });

    this.sortedRapports.sort((a, b) => {
      return b.nbr - a.nbr;
    });
  }
  /**
   * récupération de l'id d'un site donné
   * @param site le nom du site à chercher
   */
  private getSiteId(site: string) {
    const mySite = this.sites.filter((si: any) => si.libelle === site);
    return mySite.length > 0 ? mySite[0].restaurantId : "0";
  }
  /**
   * methode de traduction du classpath en localised title
   * @param classname le classname a traduire
   */
  private findTranslatedName(classname: string) {
    let name = classname;
    if (name === "FeuilleCaisseReport" && this.client === "BK") {
      name = "Synthèse CA";
    }
    this.allReports.map((rapport: any) => {
      // console.log(rapport);
      if (rapport.className.includes(classname)) {
        name = rapport.localisedTitle;
      }
    });
    return name;
  }

  get global(): boolean {
    return this.$store.getters["getGlobal"];
  }
  get sites(): any {
    return this.$store.getters["login/sites"];
  }
  get client(): string {
    return this.$store.getters["getClient"];
  }
  get allReports(): any {
    const reports = this.$store.getters["rapport/allReports"];
    let rapports = new Array();
    for (const key of Object.keys(reports)) {
      rapports = rapports.concat(reports[key]);
    }
    return rapports;
  }
  get metrics(): { [key: string]: { [key: string]: number } } {
    return this.$store.getters["rapport/metrics"];
  }
}
